import React from 'react';
import './index.scss';

function LoadMoreProgress(props: any) {
    return (
      <div className='lm-ctr'><div className='lm-bar'></div></div>
    )
}

export default LoadMoreProgress